import React, { useEffect } from 'react';

interface PageReloadProps {
  message: string;
}

const PageReload: React.FC<PageReloadProps> = ({ message }) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      return message;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [message]);

  return null;
};

export default PageReload;
